/* eslint-disable no-await-in-loop */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DetailPage from '../../../../components/moduleBuilder/DetailPage';
import Loading from '../../../../components/loading';
import permitIcon from '../../../../icons/violation.png';
import { getDefectVehicleDetail, UpdateMaintenance, postComments, getComments } from '../../redux/action';
import { GetFileName, S3Uploads } from '../../../services';

const DefectDetail=(props) => {
  const { match: { params: { id } }, history: { push } } = props;
  const dispatch = useDispatch();
  const profile = useSelector(state => state.auth.profile);
  const defectVehicleDetail= useSelector(state => state.permitManagement.defectVehicleDetail);
  const updateDefectAction= useSelector(state => state.permitManagement.updateDefectAction);
  const defectVehicleAction= useSelector(state => state.permitManagement.defectVehicleAction);
  const commentDefectAction= useSelector(state => state.permitManagement.commentDefectAction);
  const comments = useSelector(state => (state?.permitManagement?.comments));
  const airportCode = profile?.portal_airport?.code;
  const tableHeaders = [
    ['defect_at', 'Date'],
    ['category', 'Category'],
    ['sub_category', 'Sub Category'],
    ['map', 'Location'],
    ['company_name', `${profile.permit_management?.companies || 'Company'} Name`],
    ['avp_no', `${profile.permit_management?.badge || 'Badge'} Number`],
    ['veh_reg_no', 'Registration Number']
  ];
  const [answer, handleAnswer] = useState({});
  const [loader, setLoader] = useState(false);
  const [commentModal, setCommentModal] = useState(false);
  const commentCount = ([...(comments?.comments || []), ...(comments?.audit_logs || [])]?.length
    || defectVehicleDetail?.comments_count || 0);

  const handleCommentsModel = () => {
    setCommentModal(!commentModal);
  };

  const handleCloseCommentModel = () => {
    setCommentModal(false);
  };

  const submitComment = (data) => {
    dispatch(postComments(id, data));
  };

  const getFileNames = async (count) => {
    const response = await GetFileName.getPublicUploadFileName(count, airportCode);
    return response;
  };

  const doS3Upload = async (files, fileIds, entity) => {
    const response = await S3Uploads.uploadFiles(
      files,
      fileIds.filename,
      entity,
      id,
      airportCode
    );
    return response;
  };

  const uploadAttachments = async () => {
    if (answer.attachments) {
      let fileIds = '';
      fileIds = await getFileNames(answer.attachments?.length, airportCode);
      if (fileIds) {
        await doS3Upload(
          answer.attachments,
          fileIds,
          'defects'
        );
        answer.attachments=[];
        fileIds.filename.forEach((attachmentId) => {
          answer.attachments.push(attachmentId.toString());
        });
      }
    }
  };

  const handleCompleted = async () => {
    await uploadAttachments(['attachments']);
    dispatch(UpdateMaintenance(id, answer));
    setLoader(true);
  };

  useEffect(() => {
    if (updateDefectAction.success && loader) {
      push('/avp/vehicle_defect');
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateDefectAction]);

  useEffect(() => {
    setLoader(true);
    dispatch(getComments(id));
    dispatch(getDefectVehicleDetail(id));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (commentModal) {
      dispatch(getComments(id));
    }
  }, [commentModal, dispatch, id]);

  useEffect(() => {
    if (commentDefectAction.success) {
      dispatch(getComments(id));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [commentDefectAction]);

  useEffect(() => {
    if (defectVehicleAction.success && defectVehicleDetail) {
      setLoader(false);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defectVehicleAction]);

  return (
    <>
    <Loading loadingStatus={loader} />
    <DetailPage
    backRoute="/avp/vehicle_defect"
    logData={defectVehicleDetail}
    tableHeadders={tableHeaders}
    sectionHeader={{ default: profile?.permit_management?.vehicle_defect || 'Defects', id: ' ' }}
    panelHeading={{ default: `${profile.permit_management?.vehicle_defect || 'Defects'} Details`, id: ' ' }}
    icon={permitIcon}
    profile={profile}
    forDefects
    adpComments
    answer={answer}
    handleAnswer={handleAnswer}
    handleCompleted={handleCompleted}
    comments={comments}
    handleCloseComment={handleCloseCommentModel}
    handleCommentsModel={handleCommentsModel}
    commentModal={commentModal}
    commentCount={commentCount}
    submitComment={submitComment}
    {...props}
    />
    </>
  );
};

export default DefectDetail;
